export const specsort = [
    {
        id: '',
        name: 'Jantung dan Pembuluh Darah',
        slug: 'jantung-dan-pembuluh-darah',
        value: 100
    },
    {
        id: '',
        name: 'Saraf',
        slug: 'saraf',
        value: 95
    },
    {
        id: '',
        name: 'Bedah Saraf',
        slug: 'bedah-saraf',
        value: 90
    },
    {
        id: '',
        name: 'Penyakit Dalam',
        slug: 'penyakit-dalam',
        value: 85
    },
    {
        id: '',
        name: 'Anak',
        slug: 'anak',
        value: 80
    },
    {
        id: '',
        name: 'Paru',
        slug: 'paru',
        value: 75
    },
    {
        id: '',
        name: 'Dental',
        slug: 'dental',
        value: 70
    },
    {
        id: '',
        name: 'Psikologi',
        slug: 'psikologi',
        value: 65
    },
];